export const browserIdRegexp: RegExp = /^fb\.(\d+)\.(\d+)\.(\d+)$/i;
